exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ubq_{position:fixed;z-index:3005;background-color:rgba(50,50,50,.5);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._8Koz-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006;backdrop-filter:blur(4px)}.NhUO6{background-color:#fff;border:1px solid #bfbfbf;-ms-flex-item-align:center;align-self:center;z-index:3007}._2Ncf4{max-width:600px;width:90%;min-height:300px;padding:15px 20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"root": "_3ubq_",
	"background": "_8Koz-",
	"content": "NhUO6",
	"contentParams": "_2Ncf4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/ModalContainer/ModalContainer.css
// module id = 1302
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46